export default {
  new: {
    title: 'Nueva factura',
    create: 'Crear factura',
    import: 'Importar factura'
  },
  financing: 'Financiación',
  agenda: 'Agenda',
  configuration: {
    title: 'Configuración',
    companyData: 'Datos de empresa',
    users: 'Gestión de usuarios',
    notification: 'Notificación',
    invoiceFormat: 'Formato de factura',
    keys: 'Integración WS',
    catalog: 'Catálogo'
  },
  help: {
    title: 'Ayuda',
    manual: 'Manual de usuario',
    video: 'Video tutorial',
    support: 'Soporte técnico',
    about: 'Acerca de...',
    sefTicketbaiData: 'Acerca de SEF-TicketBAI'
  },
  multiCompany: {
    title: 'MultiEmpresa'
  },
  header: {
    nif: 'Razón social (NIF)',
    language: 'Idioma',
    freeAccount: 'Cuenta gratuita',
    proAccount: 'Cuenta PRO',
    contract: 'Contratar',
    proFunctionalities: {
      title: 'Funcionalidades Pro',
      subtitle: 'Facturas ilimitadas',
      func1: 'Emite y recibe un número ilimitado de facturas electrónicas para AAPP, clientes y proveedores',
      func2: 'Convierte, importa y exporta las facturas en diferentes formatos compatibles',
      func3: 'Usuarios ilimitados para gestionar el sistema',
      func4: 'Integración vía API con tu propia estructura administrativa',
      func5: 'Custodia las facturas electrónicas originales por el tiempo necesario de acuerdo con el marco jurídico estatal y europeo',
      func6: 'Recibe notificaciones de seguimiento en tiempo real del estado de las facturas',
      func7: 'Justificante de envío y recepción e impresión personalizada',
      func8: 'Recibe una formación inicial para descubrir todas las prestaciones del sistema',
      func9: 'Soporte técnico telefónico preferente en el uso del sistema',
      subscription: 'Suscripción premium',
      success: 'Su petición se está tramitando, en breve nos pondremos en contacto con ustedes.',
      error: 'Lo sentimos, se ha producido un error. Por favor inténtelo de nuevo más tarde o póngase en contacto con nosotros en:',
      close: 'Cerrar'
    }
  }
}
